import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

export const messagesAtionsTypes = {
  ADD_MESSAGE: 'status/messages/add',
  CLEAR_ADD_MESSAGE: 'status/messages/clearAndAdd',
  REMOVE_MESSAGE: 'status/messages/remove',
  CLEAR_MESSAGES: 'status/messages/clear',
}

export const useMessagesActions = () => {
  const dispatch = useDispatch()

  const addMessage = useCallback(
    (message) =>
      dispatch({
        type: messagesAtionsTypes.ADD_MESSAGE,
        payload: { message },
      }),
    [dispatch]
  )

  const clearAndAddMessage = useCallback(
    (message) =>
      dispatch({
        type: messagesAtionsTypes.CLEAR_ADD_MESSAGE,
        payload: { message },
      }),
    [dispatch]
  )

  const removeMessage = useCallback(
    (id) =>
      dispatch({
        type: messagesAtionsTypes.REMOVE_MESSAGE,
        payload: { id },
      }),
    [dispatch]
  )

  const clearMessages = useCallback(
    () =>
      dispatch({
        type: messagesAtionsTypes.CLEAR_MESSAGES,
      }),
    [dispatch]
  )

  return {
    addMessage,
    clearAndAddMessage,
    removeMessage,
    clearMessages,
  }
}
